import type {
  ShowEndpointQueryParams,
  ShowResponseEndpoint,
} from "@circle-react/api/paywallCheckoutApi.types";
import { useQuery } from "react-query";

import { paywallCheckoutApi } from "@/react/api/paywallCheckoutApi";

const key = "paywall-checkout-preview";

export const useFetchCheckoutData = (
  params: ShowEndpointQueryParams,
  enabled: boolean = true,
) => {
  const showQuery = useQuery<ShowResponseEndpoint>({
    queryKey: [key, params],
    queryFn: () => paywallCheckoutApi.show(params),
    enabled,
  });

  return {
    showQuery,
  };
};
